<template>
  <div id="hero" class="grid-item" v-scroll-reveal>

    <div id="project-label">
      <p>Recent Project</p>
      <p><b>{{$store.state.activeProject.id}} <span>OF</span> 6</b></p>
    </div>

    <div id="hero-featured">

      <project-banner
      :title="$store.state.activeProject.title"
      :type="$store.state.activeProject.type"
      :client="$store.state.activeProject.client"
      :year="$store.state.activeProject.year"
      :brief="$store.state.activeProject.brief"
      :color="$store.state.activeProject.color"
      :slug="$store.state.activeProject.slug"
      :home="true"/>

      <router-link
      tag="div"
      class="project-link"
      :to="{name: $store.state.activeProject.slug}">

        <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.37402 22C10.1354 22 12.374 17.5228 12.374 12C12.374 6.47715 10.1354 2 7.37402 2C4.6126 2 2.37402 6.47715 2.37402 12C2.37402 17.5228 4.6126 22 7.37402 22Z" stroke="black" stroke-width="3.07692" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.9121 22C21.6735 22 23.9121 17.5228 23.9121 12C23.9121 6.47715 21.6735 2 18.9121 2C16.1507 2 13.9121 6.47715 13.9121 12C13.9121 17.5228 16.1507 22 18.9121 22Z" stroke="black" stroke-width="3.07692" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3743 4.78695C23.322 6.60695 23.9128 9.16695 23.9128 12C23.9128 17.4323 21.742 21.8593 19.042 21.9969C19.9266 18.7362 21.5689 4.55695 22.3743 4.78695V4.78695Z" fill="#D9D9D9"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0413 21.9969C18.9983 21.9992 18.9552 22 18.9121 22C16.1529 22 13.9121 17.5192 13.9121 12C13.9121 6.48077 16.1529 2 18.9121 2C20.2552 2 21.4752 3.06077 22.3736 4.78692V11.9131C22.3736 15.5662 21.1929 19.0977 19.0413 21.9969V21.9969Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8352 4.78695C11.7829 6.60695 12.3737 9.16695 12.3737 12C12.3737 17.4323 10.2029 21.8593 7.50293 21.9969C8.38755 18.7362 10.0299 4.55695 10.8352 4.78695V4.78695Z" fill="#D9D9D9"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50325 21.9969C7.46018 21.9992 7.4171 22 7.37402 22C4.61479 22 2.37402 17.5192 2.37402 12C2.37402 6.48077 4.61479 2 7.37402 2C8.7171 2 9.9371 3.06077 10.8356 4.78692V11.9131C10.8356 15.5662 9.65479 19.0977 7.50325 21.9969V21.9969Z" fill="white"/>
          <path class="pupil" d="M4.57154 16.4228C6.54404 16.4228 8.14308 14.7008 8.14308 12.5766C8.14308 10.4525 6.54404 8.73047 4.57154 8.73047C2.59903 8.73047 1 10.4525 1 12.5766C1 14.7008 2.59903 16.4228 4.57154 16.4228Z" fill="black"/>
          <path class="pupil" d="M16.1096 16.4228C18.0821 16.4228 19.6812 14.7008 19.6812 12.5766C19.6812 10.4525 18.0821 8.73047 16.1096 8.73047C14.1371 8.73047 12.5381 10.4525 12.5381 12.5766C12.5381 14.7008 14.1371 16.4228 16.1096 16.4228Z" fill="black"/>
        </svg>

        <b><span :style="{color: $store.state.activeProject.color}">See more</span> on the project page</b>

         <div class="project-link-color" :style="{backgroundColor: $store.state.activeProject.color}"></div>
      </router-link>

    </div>

    <grid-render
    :particleColor="$store.state.activeProject.color"
    :renderImage="$store.state.activeProject.slug"/>

  </div>
</template>

<script>
import anime from 'animejs'
import ProjectBanner from '../ProjectBanner.vue'
import GridRender from './GridRender.vue'

export default {

  data () {
    return {

    }
  },
  components: { ProjectBanner, GridRender },
  methods: {

  },
  mounted () {
    function hoverProjectLink (duration, translateX) {
      anime.remove('.project-link')

      anime({
        targets: '.pupil',
        translateX: translateX,
        duration: duration,
        easing: 'easeOutCirc'
      })
    }

    function enterProjectLink () { hoverProjectLink(200, '+=5') };
    function leaveProjectLink () { hoverProjectLink(200, 0) };

    document.querySelector('.project-link').addEventListener('mouseenter', enterProjectLink, false)
    document.querySelector('.project-link').addEventListener('mouseleave', leaveProjectLink, false)

    hoverProjectLink(1, 1.5, 1, 0.15)
    hoverProjectLink(1, 0, 1.15, 0)
  }

}

</script>

<style lang="scss" scoped>
  #hero {
    grid-area: hero;
    position: relative;
    display: flex;
    // overflow: hidden;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    min-height: 400px;

    @include tablet-below {
      visibility: visible;
      flex-direction: column-reverse;
      order: 1;
    }

    #hero-featured {
      width: 55%;
      height: 100%;
      padding-right: 2%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      @include tablet-below {
        width: 100%;
        padding: 0;
      }

      .banner-content {
        padding: $grid-gap*2 0 0 $grid-gap*2;
        transform-origin: left;

        @include tablet-only {
          padding: $grid-gap*2;
        }

        @include phone-only {
          padding: $grid-gap;
        }
      }

      .project-link {
        width: 100%;
        padding: $grid-gap $grid-gap $grid-gap $grid-gap*2;
        border-top: 1px solid $gray3;
        box-sizing: border-box;
        position: relative;
        white-space: pre;
        @extend %linkify;

        @include tablet-below {
          white-space: initial;
        }

        @include phone-only {
          padding: $grid-gap;
        }

        b, svg, span {
          position: relative;
          z-index: 9;
          transition: all 200ms ease-out;
        }

        b {
          color: $gray4;
          line-height: 160%;
        }

        svg {
          margin-right: 12px;
          margin-bottom: -5px;
        }

        .project-link-color {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          opacity: 0;
          pointer-events: none;
          transition: opacity 200ms ease-out;
        }

        &:hover {
          .project-link-color {
            opacity: 1;
          }
          b {
            color: $white !important;

            span {
              color: $white !important;
            }
          }
        }
      }
    }

  }

  #project-label {
    position: absolute;
    top: $grid-gap;
    left: $grid-gap*2;
    text-align: left;
    pointer-events: none;
    user-select: none;

    @include tablet-below {
      right: $grid-gap;
      text-align: right;
    }

    p {
      text-transform: uppercase;
      font-size: .75rem;
      color: $gray4;
      letter-spacing: .02rem;
    }

    b {
      color: $gray6;
    }
  }

</style>
